module.exports = __webpack_public_path__ + "img/Wordpress2.ff951230.png";